<template>
  <div class="sign">
    <div class="sign_right">

      <!-- 合同签署主界面 -->
      <div class="crossTypeCard">
            <el-dialog
        title="请选择骑缝章样式"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-radio v-model="crossType" label="5">左骑缝</el-radio>
        <el-radio v-model="crossType" label="6">右骑缝</el-radio>
        <el-radio v-model="crossType" label="7">上骑缝</el-radio>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false,signContractByCross()">确 定</el-button>
        </span>
      </el-dialog>
        <div class="title">合同签署</div>

        <!-- <div class="pic" v-html="Editortex">
        </div> -->
        <div class="pic">
          <div class="pdfNak" style="position: relative" @drop="drop" @dragover.prevent ref="pdfDiv">
            <pdf ref="pdf" :src="pdfPath" :page="pageNum" :rotate="pageRotate"
                 @password="password" @progress="loadedRatio = $event" @page-loaded="pageLoaded($event)"
                 @num-pages="pageTotalNum=$event" @error="pdfError($event)" @link-clicked="page = $event">
            </pdf>

            <div v-for="(item,Tindex) in dropData" :key="Tindex">
                            <span v-show="item.ye == pageNum && item.overFlag"
                                  class="imgDrap"
                                  style="color: red;" @click="deleteItem( Tindex )"
                                  :style="{ left: item.left + 'px',top:item.top-10 + 'px'}">X</span>
              <img v-show="item.ye == pageNum"
                   :src="'data:image/png;base64,'+ item.stampTemplateBase64"
                   class="imgDrap"
                   style=" width: 136.5px; height: 136.5px; border:1px solid red"
                   :style="{ left: item.left + 'px',top:item.top + 'px' , }"
                   @mouseover.prevent="mouseover( item , $event)"
                   @click.prevent="mouseover( item , $event)"
                   @mousedown.prevent="mousedown( item , $event)"
                   @mousemove.prevent='mousemove(item, $event)'
                   @mouseup.prevent='mouseup(item, $event)'
              />
            </div>
          </div>
          <div class="pdf-tab" style="position:relative; z-index: 99999">
            <div class="btn-def" @click.stop="prePage">上一页</div>
            <div class="btn-pre">{{ pageNum }}/{{ pageTotalNum }}</div>
            <div class="btn-def" @click.stop="nextPage">下一页</div>
          </div>
        </div>
      </div>

      <!-- 右侧--我的印章 -->
      <div class="facute" id="facute" ref="myBox" v-show="$route.params.yes != 1">

        <!-- <div>
            {{dropData}}
            <hr>
            {{sealListStr}}
            <hr>
        </div> -->


        <!--  :style="searchBarFixed == true ? 'position: fixed;top:0;' : 'position: absolute;right:0;'" -->
        <div :class="searchBarFixed == true ? 'bus fixed' : 'bus abus'">

          <div class="action">
            <div class="title">我的印章</div>
            <div class="img1" v-for="(item,index) in options" :key="index" >
              <div style="position: relative">
                <div class="ukey" v-if="item.isUkey==1">
                  Ukey
                </div>
                <!--                               <div v-else style="position: absolute;top: 0;left: 0;">-->
                <!--                                   普通印章-->
                <!--                               </div>-->
                <img :src="'data:image/png;base64,'+ item.stampTemplateBase64" draggable="true"
                     @dragstart="dragstart($event,item,index)" @dragend="dragend" class="img"/>
              </div>

            </div>
          </div>

          <div>
            <div class="span">
              选中签名拖拽签署
            </div>
            <div v-if="signContractFlag==0" class="btn" @click="signContractByCommon">
              普通签署
            </div>
            <div v-if="signContractFlag==0" class="btn" @click="dialogVisible=true">
              骑缝章签署
            </div>
            <div v-if="signContractFlag==1" class="btn" @click="signContractByUkey">
              ukey签署
            </div>
          </div>

          <div class="ukey" style="margin-top: 20px;padding-left: 20px;">
            <a href="https://xiangjunkeji.cn/CM-API/ukey/client/CryptoKit.SCXJKJ.exe">
              下载ukey插件 [一台电脑安装一次即可]
            </a>
            <a href="https://xiangjunkeji.cn/CM-API/ukey/client/drive/UyeePKCSInstall.Enterprise.exe">
              下载ukey驱动 [一台电脑安装一次即可]
            </a>
            <div style="margin-top: 20px;color: red;">
              注意：<br/>
              &#12288;&#12288;1、不下载ukey驱动无法进行ukey签署<br/>
              &#12288;&#12288;2、目前ukey只支持ie内核和低版本非内核<br/>
              &#12288;&#12288;以及360低版本和国密版<br/>
              &#12288;&#12288;3、ukey签署只能签署一个章<br/>
            </div>
          </div>

        </div>
        <ukey ref="myUkey" :signatureId="signatureId"></ukey>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import ukey from '../../ukey/ukey.vue'

export default {
  components: {
    pdf,
    ukey
  },
  data() {
    return {

      pdfPath: '',

      //印模
      stampId: '',
      options: [],
      stampImg: [],
      //pdf
      Editortex: '',
      pdfUrl: "",
      pageNum: 1,
      pageTotalNum: 1,
      pageRotate: 0,
      // 加载进度
      loadedRatio: 0,
      curPageNum: 0,
      searchBarFixed: false,
      strCode: '',
      strPass: '',

      signatureId: '',
      signType:'',

      dropData: [],
      // sealListStr: [],
      is_moving: false,
      //签署印章的宽度和高度，勿动
      width: 119,
      height: 119,
      sealList: [],
      crossType: 0, 
      dialogVisible: false

    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },


  mounted() {


    if (this.$route.params.id || this.$route.params.yes) {

        // this.pdfPath = this.$global.Local + this.$route.params.pdf;
        //   this.pdfPath = 'http://127.0.0.1:5389/CM-API/' + this.$route.params.pdf;
        // console.log("PDF地址:",this.pdfPath);
        // this.pdfPath = 'http://localhost:8080/api/CM-API//upload/2021-09-06/202109061532586515772786943801.pdf';
        // alert( this.pdfPath )

        console.log("进入该页面传参", this.$route.params );

        this.pdfPath =   pdf.createLoadingTask({
            // url: this.pdfPath,
            url: this.$global.Local + this.$route.params.pdf,
            // url: 'https://xiangjunkeji.cn/CM-API//upload/2022-03-23/2022-03-232331.pdf',
            //引入pdf.js字体，templ
            cMapUrl: 'static/cmaps/', //引入pdf.js字体，templ
            // cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/',
            cMapPacked: true
        })

        this.getMysealList();
        window.addEventListener('scroll', this.handleScroll);

    } else {
      this.$router.push('contractSin');
    }

  },

  computed: {
    signContractFlag() {
      if (this.dropData.length > 0) {
        return this.dropData[0].isUkey
      }
    },
    sealListStr() {
      let pdfWidth = this.$refs.pdfDiv.offsetWidth;
      let pdfHeight = this.$refs.pdfDiv.offsetHeight;
      let dataList = [];
      this.dropData.forEach(element => {
        /**
         * 【转换原则】 1cm =  28.3x = 32.5px
         * 印章尺寸为4.2cm时   对应cfca尺寸  4.2 * 28.3= 118.86   对应px尺寸 4.2* 32.5 = 136.5
         * 841 = 29.7 [A4纸高度] * 28.3
         * 595 = 21 [A4纸宽度] * 28.3
         * */
        let leftA = element.left;
        let topA = element.top;
        let tmpA = pdfWidth / 595;  // 该系数约等于1.15
        let tmpB = pdfHeight / 841; // 该系数约等于1.15
        console.log("web页面pdf宽高-----------" + pdfWidth + "--" + pdfHeight);
        console.log("缩放系数-----------" + tmpA + "--" + tmpB);
        // let leftB = leftA /   tmpA  + 118.86/2;
        // let topB =  topA / tmpB  + 118.86/2 ;

        let height2CFca = 841;
        // 页面高度不足一页A4纸
        if( pdfHeight < 965){
            tmpB = 1.15;
            height2CFca = pdfHeight / 1.15
        }
        console.log("缩放系数-----------" + tmpA + "--" + tmpB);

        // let leftB = leftA /   tmpA  + 118.86/2;
        // let topB =  topA / tmpB  + 118.86/2 ;

        let leftB = leftA / tmpA;
        let topB = ( height2CFca - 118.86) - topA / tmpB;

        // let leftB = leftA / tmpA;
        // let topB = (841 - 118.86) - topA / tmpB;

        console.log("left:=====" + leftB, "top:====" + topB + "最后的坐标");
        dataList.push({
          signatureId: element.id,
          stampId: element.stampId,
          page: element.pageNum,
          lx: leftB,
          ly: topB,
          sealLocation: '待定-无数据',
          sealReason: '待定-无数据',
          sealPerson: this.$store.store.state.userData.name, //签章人
          sealCode: element.signCode, //name
          sealPassword: element.sealPassword,
          width: this.width,
          height: this.height
        });
      });
      return dataList;
    },
    ukeyListStr() {
      let pdfWidth = this.$refs.pdfDiv.offsetWidth;
      let pdfHeight = this.$refs.pdfDiv.offsetHeight;
      let dataList = [];
      this.dropData.forEach(element => {
        /**
         * 【转换原则】 1cm =  28.3x = 32.5px
         * 印章尺寸为4.2cm时   对应cfca尺寸  4.2 * 28.3= 118.86   对应px尺寸 4.2* 32.5 = 136.5
         * 841 = 29.7 [A4纸高度] * 28.3
         * 595 = 21 [A4纸宽度] * 28.3
         * */
        console.log("web页面pdf宽高-----------" + pdfWidth + "--" + pdfHeight);
        let leftA = element.left;
        let topA = element.top;
        let tmpA = pdfWidth / 595;  // 该系数约等于1.15
        let tmpB = pdfHeight / 841; // 该系数约等于1.15

        // 页面高度不足一页A4纸
        let height2CFca = 841;
        if( pdfHeight < 965){
            tmpB = 1.15;
            height2CFca = pdfHeight / 1.15
        }
        console.log("缩放系数-----------" + tmpA + "--" + tmpB);
        // let leftB = leftA /   tmpA  + 118.86/2;
        // let topB =  topA / tmpB  + 118.86/2 ;

        let leftB = leftA / tmpA;
        let topB = ( height2CFca - 118.86) - topA / tmpB;

        console.log("left:=====" + leftB, "top:====" + topB + "最后的坐标");
        dataList.push({
          page: element.pageNum,
          lx: leftB,
          ly: topB,
        });
      });
      return dataList;
    },
  },

  methods: {

    // 获取我的印章列表
    getMysealList() {
      let param = new FormData();
      param.append('token', this.$global.token);
      param.append('state', 1);
      let _this = this;
      // 【API请求】----获取印章列表
      _this.api.getMyCertList(param).then(res => {
        let needData = [];
        res.data.forEach(item => {
          if (item.state === "1") {
            needData.push(item);
          } else {
            return;
          }
        });
        _this.options = needData;
      })
    },
    // 鼠标滚动事件
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector('#facute').offsetTop;
      if (scrollTop > 500 && scrollTop < 1200) {
        this.searchBarFixed = true
      } else {
        this.searchBarFixed = false
      }
    },

    deleteItem(index) {
      this.dropData.splice(index, 1);
    },
    mouseover(item, e) {
      item.overFlag = true;
    },
    // 拖动图片（将图片放入PDF，在进行拖动图片）
    mousedown(item, e) {
      const odiv = e.target;
      const disX = e.clientX - odiv.offsetLeft;
      const disY = e.clientY - odiv.offsetTop;
      this.is_moving = true;
      document.onmousemove = e => {
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        let pdfWidth = this.$refs.pdfDiv.offsetWidth;
        let pdfHeight = this.$refs.pdfDiv.offsetHeight;
        if (top <= -1 || left <= -1) {
          return
        }
        if (top - pdfHeight + 130 > -1 || left - pdfWidth + 130 > -1) {
          return
        }


        if (this.is_moving) {
          item.left = left;
          item.top = top;
          console.log("拖动图片", item.left, item.top);
        } else {
          return;
        }

      }
    },

    mousemove: function (item, e) {
    },
    mouseup: function (site, e) {
      this.is_moving = false;
    },


    dragstart(e, item, index) {
      e.dataTransfer.setData('item', JSON.stringify(item));
      e.dataTransfer.setData('index', index);
    },
    dragend(e) {
      e.dataTransfer.clearData();
    },
    //拖动图片时间监听
    drop(e) {
      let sealInfoStr = e.dataTransfer.getData('item');
      let index = e.dataTransfer.getData('index');
      let sealInfoObj = JSON.parse(sealInfoStr);

      let sealImageData = {
        id: sealInfoObj.id,
        name: sealInfoObj.name,
        isUkey: sealInfoObj.isUkey,
        signType: sealInfoObj.signType,
        stampId: sealInfoObj.stampId,
        signCode: sealInfoObj.signCode,
        pageNum: this.pageNum,
      };


      sealImageData.ye = this.pageNum; // 印章所在页码

      console.log(e.layerX, e.layerY, e, '拖拽释放事件,坐标');

      sealImageData.left = e.layerX;
      sealImageData.top = e.layerY;


      // 判断是否可以继续新增该印章信息
      if (this.checkAddSealImgFlag(sealImageData)) {
        sealImageData.stampTemplateBase64 = sealInfoObj.stampTemplateBase64;
        //验证印章密码
        this.handlYinZ(sealImageData, index);
      } else {
        this.$message.error('仅限一种类型章');
        return;
      }

    },
    // 【API请求】----验证印章密码
    handlYinZ(item, index) {
      let _this = this;
      _this.$prompt('请输入印章密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password',
        closeOnClickModal: false,
        inputPattern: /(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)/,
        inputErrorMessage: '密码必须由大写字母、小写字母、数字、特殊符号中的2种及以上类型组成!'
      }).then(({value}) => {
        // 封装请求参数
        let param = new FormData();
        param.append('token', _this.$global.token);
        param.append('id', item.stampId);
        param.append('sealCode', item.signCode);
        param.append('sealPassword', value);
        // 【API请求】----验证印章密码
        _this.api.checkSealPwd(param).then(res => {
          _this.$message.success('印章密码验证成功,可以使用');
          _this.stampId = item.stampId;
          _this.signatureId = item.id;
          _this.signType = item.signType;
          item.sealPassword = value;
          this.dropData.push(item);
        })

      }).catch(() => {
        _this.$message({type: 'info', message: '取消输入'});
      });
    },
    // 校验是否可以继续新增签章
    checkAddSealImgFlag(sealImageData) {
      if (this.dropData.length === 0) {
        return true;
      }
      for (let index = 0; index < this.dropData.length; index++) {
        const element = this.dropData[index];
        if (sealImageData.id === element.id) {
          return true;
        }
      }
      return false;
    },


    // 【】普通方式签署合同
    signContractByCommon() {
      let _this = this;
      if (_this.stampId === '') {
        _this.$message.info('请选择印模');
        return;
      }
      _this.$confirm('是否要进行合同签署?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 封装请求参数
        let param = {};
        param.token = _this.$global.token;
        // param.useName = _this.$global.webData.name;
        param.useName = _this.signType == '1' ? _this.$global.webData.name : _this.$global.webData.companyName;
        param.contactId = _this.$route.params.id;
        // param.customerType = _this.$global.webData.farenCode ? '2' : '1';
        param.customerType = _this.signType;
        param.isUseKey = '0';
        param.signatureId = _this.signatureId;
        param.sealListStr = JSON.stringify(_this.sealListStr);
        // 对象信息封装转化为  FormData
        let formData = new FormData();
        Object.keys(param).forEach((value, key) => {
          formData.append(value, param[value]);
        });
        // 【API请求】----普通印章 签署合同
        _this.api.sealContact(formData).then(res => {
          _this.$message.success('签署完成');
          _this.$router.push('loginMenu');
        })
      }).catch((e) => {
        _this.$message.error('签署失败，请稍后再试');
      });
    },

     
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
     signContractByCross() {
      let _this = this;
      if (_this.stampId === '') {
        _this.$message.info('请选择印模');
        return;
      }
       if (_this.crossType == 0) {
        _this.$message.info('请选择骑缝章样式');
        return;
      }
      _this.$confirm('是否要进行合同签署?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 封装请求参数
        let param = {};
        param.token = _this.$global.token;
        // param.useName = _this.$global.webData.name;
        param.useName = _this.signType == '1' ? _this.$global.webData.name : _this.$global.webData.companyName;
        param.contactId = _this.$route.params.id;
        // param.customerType = _this.$global.webData.farenCode ? '2' : '1';
        param.customerType = _this.signType;
        param.isUseKey = '0';
        param.signatureId = _this.signatureId;
        param.sealListStr = JSON.stringify(_this.sealListStr);
        param.crossType = _this.crossType;
        // 对象信息封装转化为  FormData
        let formData = new FormData();
        Object.keys(param).forEach((value, key) => {
          formData.append(value, param[value]);
        });
        // 【API请求】----普通印章 签署合同
        _this.api.sealContact(formData).then(res => {
          _this.$message.success('签署完成');
          _this.$router.push('loginMenu');
        })
      }).catch((e) => {
        _this.$message.error('签署失败，请稍后再试');
      });
    },

    // 【】Ukey方式签署合同
    signContractByUkey() {
      let _this = this;
      let pdfWidth = this.$refs.pdfDiv.offsetWidth;
      let pdfHeight = this.$refs.pdfDiv.offsetHeight;
      var userAgent = navigator.userAgent;
      if (_this.stampId === '') {
        _this.$message.info('请选择印模');
        return
      }
      try {
        this.$refs.myUkey.SelectCertificateOnClick()
      } catch (e) {
        _this.$message.info('请确认是否插入Ukey，或更换浏览器重试');
        return;
      }
      if (this.$refs.myUkey.GetCertInfoOnClick()) {
        let formData = new FormData();
        let pdfLX = 0;
        let pdfLY = 0;
        //判断X轴
        /**
         * 【转换原则】 1cm =  28.3x = 32.5px
         * 印章尺寸为4.2cm时   对应cfca尺寸  4.2 * 28.3= 118.86   对应px尺寸 4.2* 32.5 = 136.5
         * 841 = 29.7 [A4纸高度] * 28.3
         * 595 = 21 [A4纸宽度] * 28.3
         * */
        console.log("web页面pdf宽高-----------" + pdfWidth + "--" + pdfHeight);

        let leftA = _this.dropData[0].left;
        let topA = _this.dropData[0].top;

        let tmpA = pdfWidth / 595;  // 该系数约等于1.15
        let tmpB = pdfHeight / 841; // 该系数约等于1.15

         let height2CFca = 841;
        // 页面高度不足一页A4纸
        if( pdfHeight < 965){
            tmpB = 1.15;
            height2CFca = pdfHeight / 1.15
        }
        console.log("缩放系数-----------" + tmpA + "--" + tmpB);

        // let leftB = leftA /   tmpA  + 118.86/2;
        // let topB =  topA / tmpB  + 118.86/2 ;

        let leftB = leftA / tmpA;
        let topB = ( height2CFca - 118.86) - topA / tmpB;

        console.log("left:=====" + leftB, "top:====" + topB + "最后的坐标");
        formData.append('contactId', _this.$route.params.id);
        formData.append('token', _this.$global.token);
        formData.append('lx', leftB);
        formData.append('ly', topB);
        formData.append('pageNo', _this.dropData[0].ye);
        formData.append('stampId', _this.stampId);
        formData.append('useName', _this.$global.webData.name);
        formData.append('signatureId', _this.signatureId);
        formData.append('isUseKey', '1');
        formData.append('width', this.width);
        formData.append('height', this.height);
        // alert(1);
        // return;
        //计算HASH
        _this.api.calPdfHash(formData).then(res => {
          //签署ukey合同
          this.$refs.myUkey.SignOnClick(res.data.pdfSealHash, res.data.pdfId, _this.$route.params.id,JSON.stringify(_this.ukeyListStr));
        })
      }
    },


    //pdf
    prePage() {
      let p = this.pageNum;
      p = p > 1 ? p - 1 : this.pageTotalNum;
      this.pageNum = p
    },
    nextPage() {
      let p = this.pageNum;
      p = p < this.pageTotalNum ? p + 1 : 1;
      this.pageNum = p
    },
    clock() {
      this.pageRotate += 90
    },
    counterClock() {
      this.pageRotate -= 90
    },
    password(updatePassword, reason) {
      updatePassword(prompt('password is "123456"'))
    },
    pageLoaded(e) {
      this.curPageNum = e
    },
    pdfError(error) {
      console.error(error)
    },
    pdfPrintAll() {
      this.$refs.pdf.print()
    },
    pdfPrint() {
      this.$refs.pdf.print(100, [1, 2])
    },
  }
}
</script>

<style scoped lang="less">
@import '../../../../static/less/xm.less';

.ukeyBtn {
  font-size: 10px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-image: linear-gradient(270deg,
  #1e6eee 0%,
  #109ee7 50%,
  #01cee0 100%),
  linear-gradient(#ffffff, #ffffff);
  background-blend-mode: normal,
  normal;
  box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
  color: #fff;
}


.sign {
  width: @a;
  height: auto;

  .sign_right {
    width: @a;
    height: auto;
    display: @flex;
    margin-left: 4%;
    position: relative;
    overflow: hidden;

    .puint {
      width: auto;
      height: auto;

      .title {
        width: 672px;
        height: 24px;
        font-family: MicrosoftYaHei-Bold;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #333333;
      }
    }

    .pic {
      width: 768px;
      height: auto;
      margin-top: 40px;
      border: solid 1px #aaaaaa;

      .imgDrap {
        width: 120px;
        height: 120px;
        cursor: pointer;
        position: absolute;
        object-fit: cover;
      }


      .pdf-tab {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn-def {
          width: 100px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background-image: linear-gradient(270deg,
          #1e6eee 0%,
          #109ee7 50%,
          #01cee0 100%),
          linear-gradient(#000000,
          #000000);
          background-blend-mode: normal,
          normal;
          color: #fff;
          font-size: 24px;
          cursor: pointer;
        }

        .btn-pre {
          width: 100px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 24px;

          border: solid 0.013333rem #aaaaaa;
          margin: 0 20px;
        }
      }
    }

    .facute {
      width: 300px;
      height: auto;
      position: relative;

      // margin-left: 50px;
      .span {
        width: @a;
        height: 17px;
        text-align: center;
        font-family: MicrosoftYaHei;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #333333;
        margin-top: 30px;
      }

      .btn {
        width: 120px;
        height: 40px;
        margin-top: 25px;
        line-height: 40px;
        text-align: center;
        background-image: linear-gradient(270deg,
        #1e6eee 0%,
        #109ee7 50%,
        #01cee0 100%),
        linear-gradient(#000000,
        #000000);
        background-blend-mode: normal,
        normal;
        letter-spacing: 1px;
        color: #fff;
        cursor: pointer;
      }

      .abus {
        position: absolute;
        top: 60px;
        right: 0;
      }

      .fixed {
        position: fixed;
        top: 0;
      }

      .bus {
        width: 300px;
        height: auto;
        @column();

        .action {
          width: @a;
          height: auto;

          .title {
            text-align: center;
            font-family: MicrosoftYaHei-Bold;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;
          }

          .select {
            width: auto;
            height: auto;
            margin-top: 20px;
          }

          .sempetImg {
            margin: 30px 0;
          }

          span {
            width: 231px;
            font-family: MicrosoftYaHei-Bold;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;
            text-align: end;
          }

          .img2 {
            width: 115px;
            height: 115px;
            margin-left: 30px;
            display: inline-block;
            border: solid 1px #000;
            margin-top: 20px;

            .img {
              width: 115px;
              height: 115px;
              cursor: pointer;
              z-index: 1000;
              position: absolute;
              object-fit: cover;

            }
          }

          .img1 {
            width: 115px;
            height: 115px;
            margin-left: 30px;
            display: inline-block;
            border: solid 1px #a199995c;
            margin-top: 20px;

            .img {
              width: 115px;
              height: 115px;
              cursor: pointer;
              z-index: 1000;
              object-fit: cover;

            }

            .ukey {
              width: 36px;
              height: 36px;
              position: absolute;
              top: -10px;
              left: -10px;
              border-radius: 50%;
              background-image: linear-gradient(270deg,
              #1e6eee 0%,
              #109ee7 50%,
              #01cee0 100%),
              linear-gradient(#ffffff,
              #ffffff);
              background-blend-mode: normal,
              normal;
              box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 10px;
            }
          }
        }

      }

      .meAcun {
        width: @a;
        height: 40px;
        display: @flex;
        justify-content: space-between;

        .btn {
          width: 120px;
          height: 40px;
          background-color: #f2f2f2;
          border: solid 1px #aaaaaa;
          line-height: 40px;
          text-align: center;
          letter-spacing: 1px;
          color: #333333;
        }
      }

      .addImg {
        width: @a;
        height: auto;
        margin-top: 30px;

        .guint {
          width: 250px;
          height: 250px;
          @row();
          margin-top: 30px;
          cursor: pointer;

          img {
            width: @a;
            height: @a;
            object-fit: cover;
          }
        }

        .guit {
          width: 250px;
          height: 250px;
          @row();
          cursor: pointer;

          img {
            width: @a;
            height: @a;
            object-fit: cover;
          }
        }

        .span {
          width: @a;
          height: 17px;
          text-align: center;
          font-family: MicrosoftYaHei;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #333333;
          margin-top: 18px;
        }

        .btn {
          width: 120px;
          height: 40px;
          margin-top: 25px;
          margin-left: 65px;
          line-height: 40px;
          text-align: center;
          background-image: linear-gradient(270deg,
          #1e6eee 0%,
          #109ee7 50%,
          #01cee0 100%),
          linear-gradient(#000000,
          #000000);
          background-blend-mode: normal,
          normal;
          letter-spacing: 1px;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/contract/sign_contract.vue